export class ClientQueryPaginatedDTO {
  offset?: number;
  limit?: number;
  search?: string;
  filter?: string;
  order?: string;
}
